/** Only already-public content may be serialized into a page's HTML. */
export function canHydratePublicQuery(query: {
  queryKey: readonly unknown[];
  state: { status: string };
}): boolean {
  return query.state.status === "success" &&
    ["meetings", "meeting"].includes(String(query.queryKey[0]));
}